import {
  PostPositionInterface,
  DeletePositionInterface,
  UpdatePositionInterface,
} from '@/data/payload/contracts/PositionRequest'

export class UpdatePositionRequest implements UpdatePositionInterface {
  private code: string
  private description: string

  constructor(code: string, description: string) {
    this.code = code
    this.description = description
  }
  public toJSON() {
    const data = {
      code: this.code,
      description: this.description,
    }
    return JSON.stringify({
      data,
    })
  }
}
export class DeletePositionRequest implements DeletePositionInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class PositionApiRequest implements PostPositionInterface {
  private code: string
  private description: string

  constructor(code: string, description: string) {
    this.code = code
    this.description = description
  }

  public toJSON() {
    const data = {
      code: this.code,
      description: this.description,
    }

    return JSON.stringify({
      data,
    })
  }
}
